"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FacebookSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FacebookSVG = function FacebookSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M30,16.08A14,14,0,1,0,13.81,30V20H10.26V16h3.55V13c0-3.53,2.09-5.48,5.29-5.48a20.46,20.46,0,0,1,3.13.28v3.46H20.47A2,2,0,0,0,18.2,13a1.7,1.7,0,0,0,0,.45V16h3.88l-.62,4H18.19V30A14.06,14.06,0,0,0,30,16.08Z"
  }));
};
exports.FacebookSVG = FacebookSVG;
FacebookSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FacebookSVG);
exports.default = _default;